import React from 'react';
import type { ApiEnvs } from '@peloton/external-links/models';
import { onAuthError, onAuthProviderEvent } from '@auth/monitoring';
import { AuthProvider as PAuthProvider } from '@auth/oauth/AuthProvider';
import { toAuthEnv } from '@members/env/api';
import { toAuth0Config, apiToMaybeOauthEnv } from '@members/env/auth0';

const maybeOrigin = typeof window === 'undefined' ? '' : window.origin;

/**
 * Members-side wrapper around the shared `@auth/oauth` AuthProvider.
 */
const MembersAuthProvider: React.FC<React.PropsWithChildren<{ apiEnv: ApiEnvs }>> = ({
  children,
  apiEnv,
}) => {
  const oauthEnv = apiToMaybeOauthEnv(apiEnv);
  const auth0Config = toAuth0Config(apiEnv, oauthEnv);
  const authEnv = toAuthEnv();

  return (
    <PAuthProvider
      domain={auth0Config.domain!}
      clientId={auth0Config.clientId!}
      authorizationParams={{
        audience: auth0Config.authorizationParams?.audience,
        redirect_uri: `${maybeOrigin}/callback`,
        scope: 'openid profile email offline_access',
      }}
      authEnv={authEnv}
      onAuthEvent={onAuthProviderEvent}
      onError={onAuthError}
    >
      {children}
    </PAuthProvider>
  );
};

export default MembersAuthProvider;
